import { PropsWithChildren } from 'react'

import AppSettingsContext, { AppManagementContextProps } from './context'

type Props = PropsWithChildren<
  {
    appId: string
    cloudDomainUrl?: string
    wsEnabled?: boolean
    httpEnabled?: boolean
  } & Omit<
    AppManagementContextProps,
    'cloudDomainUrl' | 'wsEnabled' | 'httpEnabled'
  >
>

/** Context provider for the app management area. */
const AppManagementContextProvider = ({
  appId,
  cloudDomainUrl,
  wsEnabled,
  httpEnabled,
  children,
  ...ctx
}: Props) => {
  return (
    <AppSettingsContext.Provider
      value={{
        appId,
        cloudDomainUrl: ctx.isDomainReady ? cloudDomainUrl : undefined,
        wsEnabled,
        httpEnabled,
        ...ctx,
      }}
    >
      {children}
    </AppSettingsContext.Provider>
  )
}

export default AppManagementContextProvider
